import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-m', 'LetterM', [["path",{"d":"M6 20v-16l6 14l6 -14v16"}]]);